import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { AllSavedPrescriptions } from "../../Apis/AuthApiServices";
import {
  loadingAllSavedPrescriptions,
  setAllSavedPrescriptions,
} from "../Slice/AllSavedPrescriptionsSlice";

function* onLoadAllSavedPrescriptionsAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("doctorId", payload.doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  try {
    const result: AxiosResponse = yield AllSavedPrescriptions(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setAllSavedPrescriptions({
          AllsavedPrescriptionData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setAllSavedPrescriptions({
          AllsavedPrescriptionData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setAllSavedPrescriptions({
        AllsavedPrescriptionData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadAllSavedPrescriptions() {
  yield takeLatest(
    loadingAllSavedPrescriptions.type,
    onLoadAllSavedPrescriptionsAsync
  );
}

const AllSavedPrescriptionsSaga = [fork(onLoadAllSavedPrescriptions)];
export default AllSavedPrescriptionsSaga;
